/**
 * @file index.tsx
 *
 * @fileoverview Renders an image for the 404 screen.
 */
import React from 'react';
import { SearchLocationsIcon } from '~/vcl/icons/SearchLocations';

interface NotFoundImageSlotProps {}
export default function NotFoundImageSlot({}: NotFoundImageSlotProps) {
  return <SearchLocationsIcon title="Page not found" />;
}
